export const menuItems = [
         {
           id: 1,
           label: "Dashboard",
           icon: "bx-home-circle",
           link: "/dashboard",
         },
         {
           id: 2,
           label: "Info",
           isTitle: true,
         },
         {
           id: 5,
           label: "Info",
           icon: "bx-area",
           subItems: [
             {
               id: 1,
               label: "Regulations",
               link: "/info/Regulations",
               parentId: 5,
             },

             {
               id: 6,
               label: "Question",
               link: "/info/Question",
               parentId: 5,
             },
             {
               id: 7,
               label: "Privilege",
               link: "/info/Privilege",
               parentId: 5,
             },
             {
               id: 8,
               label: "CalculationKind",
               link: "/info/CalculationKind",
               parentId: 5,
             },
             {
               id: 9,
               label: "Instruction",
               link: "/info/Instruction",
               parentId: 5,
             },
             {
               id: 10,
               label: "Offer",
               link: "/info/Offer",
               parentId: 5,
             },
             {
              id: 12,
              label: "Qualification",
              link: "/info/Qualification",
              parentId: 5,
            },
            {
              id: 12,
              label: "QualificationRequirment",
              link: "/info/QualificationRequirment",
              parentId: 5,
            },
           ],
         },

         // {
         //   id: 8,
         //   label: "Management",
         //   isTitle: true,
         // },
         // {
         //   id: 4,
         //   label: "Management",
         //   icon: "bx bx-cog toggle-right",
         //   subItems: [
         //     {
         //       id: 1,
         //       label: "role",
         //       link: "/managment/role",
         //       parentId: 4,
         //     },
         //   ],
         // },
       ];
